<template>
  <div>
    <b-row>

      <b-col md="12" class="d-flex align-items-center justify-content-between mb-1">
        <span class="text-muted" style="font-size:0.78rem;">Los campos con * son obligatorios</span>
        <b-link v-if="item && viewEdit" href="javascript:void(0);" class="small" @click="openFullEdit()">
          <AppIcon icon="box-arrow-up-right" class="mr-1"></AppIcon>
          Ver ficha completa
        </b-link>
      </b-col>

      <b-col md="12">
        <b-form-group label="Nombre *" label-size="sm">
          <b-form-input v-model="form.name" size="sm" placeholder="Ej: Dólar Estadounidense"
                        ref="inputName" @keyup.enter.native="save()" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Código *" label-size="sm">
          <b-form-input v-model="form.code" size="sm" placeholder="Ej: USD" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Símbolo *" label-size="sm">
          <b-form-input v-model="form.symbol" size="sm" placeholder="Ej: $" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Cotización" label-size="sm">
          <b-form-input v-model="form.rate" type="number" size="sm" min="0" step="0.01" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group label="Estado" label-size="sm"
                      :description="isBaseCurrency ? 'El Peso Argentino no se puede inactivar: está configurado como moneda por default en todo el sistema.' : ''">
          <b-form-checkbox v-model="form.status" switch size="sm" :disabled="loading || isBaseCurrency">
            {{form.status ? 'Activo' : 'Inactivo'}}
          </b-form-checkbox>
        </b-form-group>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="dark" size="sm" @click="save()" :disabled="loading || !form.name.trim() || !form.code.trim() || !form.symbol.trim()">
          <AppIcon icon="check" class="mr-1"></AppIcon>
          Guardar
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>
<script>
  import serviceAPI from '../services'

  const emptyForm = () => ({ name: '', code: '', symbol: '', rate: 0, status: true })

  export default {
    props: {
      item: { type: Object, default: null },
      viewEdit: { type: String, default: '' },
      viewEditParamID: { type: String, default: '' },
    },
    data() {
      return { form: emptyForm(), loading: false }
    },
    computed: {
      // Peso Argentino: mismo criterio que crudCurrency.vue / CurrencyController.php
      // (BASE_CURRENCY_ID) -- es la única moneda que no se puede inactivar.
      isBaseCurrency() {
        return !!(this.item && this.item.id === 1)
      },
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if (val) { this.loadForEdit(val.id) } else { this.form = emptyForm() }
        },
      },
    },
    mounted() {
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      loadForEdit(id) {
        this.loading = true
        serviceAPI.obtenerMoneda(id)
          .then((r) => {
            this.form = Object.assign(emptyForm(), r.data)
            this.form.name = this.form.name || ''
            this.form.code = this.form.code || ''
            this.form.symbol = this.form.symbol || ''
            this.form.rate = this.form.rate || 0
            this.form.status = r.data.status !== undefined ? r.data.status : true
          })
          .finally(() => { this.loading = false })
      },
      openFullEdit() {
        var params = {}
        params[this.viewEditParamID] = this.item.id
        window.open(this.$router.resolve({ name: this.viewEdit, params: params }).href, '_blank')
      },
      save() {
        if (!this.form.name.trim() || !this.form.code.trim() || !this.form.symbol.trim()) return
        if (this.isBaseCurrency && !this.form.status) {
          this.$awn.alert('El Peso Argentino no se puede inactivar')
          return
        }
        this.loading = true
        var isEdit = this.item && this.item.id
        var data = Object.assign({}, this.form, {
          name: this.form.name.trim(),
          code: this.form.code.trim(),
          symbol: this.form.symbol.trim(),
          rate: this.form.rate,
          status: this.form.status,
        })
        var call = isEdit
          ? serviceAPI.editarMoneda(Object.assign({}, data, { id: this.item.id }))
          : serviceAPI.agregarMoneda(data)
        call
          .then((r) => {
            this.$awn.success(isEdit ? 'Moneda actualizada' : 'Moneda creada')
            this.$emit('saved', r.data)
          })
          .catch(() => { this.$awn.alert('Error al guardar la moneda') })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
